import {Box} from "@mui/material";
import LoadingMessage from "./LoadingMessage";
import * as React from "react";

export default function PageLoader() {
    return <Box sx={{display: "flex", flexDirection: "column", justifyContent: 'center', height: '100vh'}}>
        <LoadingMessage/>
    </Box>;
}
